export default __webpack_public_path__ + "static/media/modelos.7bed9fc0.png";